module.exports = __webpack_public_path__ + "static/img/rank_330.8f30645.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_330.png
// module id = Mkdx
// module chunks = 0